// DividersInfoSection.js

import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Section that has three blocks of information with divider
 * @param {} props 
 * @returns 
 */
function DividersInfoSection(props) {

    var { t } = useTranslation();

    return (
        <section className="uk-section-small uk-padding-remove-top uk-margin-large-top  uk-margin-large-bottom">
                    <div className="uk-grid-divider uk-child-width-1-3@s" data-uk-grid>
                        <div>
                            <h4 className="uk-heading-line uk-text-small"><span>Documents Commonly Required</span></h4>
                            <ol className="uk-list uk-list-decimal">
                                <li>Completed visa application form signed by applicant.</li>
                                <li>Valid passport with at least two blank pages and six months validity beyond intended stay.</li>
                                <li>Recent passport-sized photographs meeting consular specifications.</li>
                                <li>Proof of accommodation or invitation letter for business visits.</li>
                                <li>Travel medical insurance covering the period of stay.</li>
                            </ol>
                        </div>

                        <div>
                            <h4 className="uk-heading-line uk-text-small"><span>Processing Options</span></h4>
                            <p>
                                Standard processing, express processing, and corporate-arranged bulk submissions. Additional consular fees and courier charges may apply depending on jurisdiction. Corporate clients can request account-based invoicing and consolidated shipment of documents.
                            </p>
                        </div>

                        <div>
                            <h4 className="uk-heading-line uk-text-small"><span>Contact & Next Steps</span></h4>
                            <p>
                                For dossier evaluation and formal quote, submit a documents list online. Service-level agreements available for recurring corporate submissions and project-based mobilisation support.
                            </p>
                            <a href="/apply-visa" className="uk-button uk-button-jai uk-margin-top">Contact Sales (WhatsApp)</a>
                        </div>
                    </div>
                </section>
    );
}

export default DividersInfoSection;